import { createFileRoute, redirect } from '@tanstack/react-router';
import { getPortalToken } from '@/api/portal';
import { PortalDashboard } from '@/components/PortalDashboard';

export const Route = createFileRoute('/portal/')({
  beforeLoad: () => {
    if (!getPortalToken()) {
      throw redirect({ to: '/portal/login' });
    }
  },
  component: PortalDashboard,
});
